export { default } from './BaseHomeSection';
